import i18n from 'i18n';
import { ColDef } from '@ag-grid-community/core';

export const xccaColumnDefs: ColDef[] = [
  {
    headerName: i18n.t('xcca.grid.certid'),
    field: 'CERTID',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.commonname'),
    field: 'COMMONNAME',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.afType'),
    field: 'AFTYPE',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.liType'),
    field: 'LITYPE',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.expireDate'),
    field: 'EXPIREDATE',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.status'),
    field: 'STATUS',
    resizable: true,
    minWidth: 97
  },
  {
    headerName: i18n.t('xcca.grid.errormsg'),
    field: 'ERRMSG',
    resizable: true,
    flex: 1
  }
];
